export default {
    accessToken: 'pk.eyJ1IjoibnN0Y2FjdHVzIiwiYSI6ImNsaGY1ZzFodjFzZmMzbG51Y2IweDBpcTcifQ.8iIG7IEk532qvaPnmY8ayw',
};
